var React = require('react');

function ArrowCarousel (props) {
    return React.createElement("svg",props,React.createElement("path",{"id":"Path_35","data-name":"Path 35","d":"M1870,965l10-10,10,10","transform":"translate(966.061 -1868.939) rotate(90)","fill":"none","stroke":"#fff","strokeWidth":"3"}));
}

ArrowCarousel.defaultProps = {"width":"13.182","height":"22.121","viewBox":"0 0 13.182 22.121"};

module.exports = ArrowCarousel;

ArrowCarousel.default = ArrowCarousel;
